import styled from 'styled-components'

export const ShortcutHint_s = styled.div`
  position: absolute;
  visibility: ${(props: {visible: boolean}) => props.visible ? "visible" : "hidden"};
  background-color: #232323 !important;
  color: white;
  padding: 1px 5px 0px 5px;
  box-shadow: 0 0 5px #737373;
  z-index: 800;
  font-family: "Roboto-Light", sans-serif;
  font-size: 12px;

  &.left-nav-hint {
    left: 64px;
    margin-top: -24px;
  }

  &.header-hint {
    top: 38px;
  }

  &.subnav-hint {
    position: absolute;
    top: 32px;
  }

  &.help-hint {
    position: fixed;
    bottom: 80px;
    right: 40px;
  }
`